const baseurl = 'http://www.gzzjd.com:8090';
const baseurl1 = 'http://192.168.28.88:8080';
export default {
  baseurl,
  baseurl1
};



// WEBPACK FOOTER //
// ./src/assets/api/baseUrl.js